module.exports = __webpack_public_path__ + "img/UTFLIG-1.bfac9801.jpg";